import { Button, CloseButton } from 'components';
import { noop } from 'lodash/fp';
import React, { CSSProperties, FC, MutableRefObject } from 'react';
import { v4 as uuid } from 'uuid';

import { ButtonContainer, Message, StyledPopup, Wrapper } from './styled';

interface PopupEventProps {
  wrapperRef?: MutableRefObject<any>;
  popupMessageText?: string;
  popupButtons?: any[];
  buttonContainerStyles?: any;
  popupStyles: CSSProperties;
  innerComponent: any;
  closePopup?: () => void;
  darkBackground?: boolean;
  extraMessageStyle?: CSSProperties;
}

const PopupEvent: FC<PopupEventProps> = ({
  popupMessageText,
  popupButtons = [],
  buttonContainerStyles,
  popupStyles,
  innerComponent,
  closePopup = noop,
  wrapperRef,
  darkBackground = true,
  extraMessageStyle,
}) => {
  const handleConfirmAndClose = (confirmCallback) => {
    confirmCallback();
    closePopup();
  };

  return (
    <Wrapper
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      darkBackground={darkBackground}
    >
      <StyledPopup
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0 }}
        ref={wrapperRef}
        id="popUpWrapper"
        popupStyles={popupStyles}
      >
        <CloseButton onClick={closePopup} />
        {popupMessageText && (
          <Message style={extraMessageStyle}>{popupMessageText}</Message>
        )}
        {innerComponent}
        {popupButtons && (
          <ButtonContainer buttonContainerStyles={buttonContainerStyles}>
            {popupButtons.map((button) => (
              <Button
                key={uuid()}
                width="80%"
                type="button"
                variant={button.variant || 'default'}
                buttonStyles={button.buttonStyles}
                IconComponent={button.IconComponent || null}
                onClick={
                  button.handleConfirm === noop
                    ? closePopup
                    : () => handleConfirmAndClose(button.handleConfirm)
                }
              >
                {button.popupButtonText}
              </Button>
            ))}
          </ButtonContainer>
        )}
      </StyledPopup>
    </Wrapper>
  );
};

export default PopupEvent;
